//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.MillingToolBuilder.js";
import "../CAM/CAM.InheritableDoubleBuilder.js";
let d=[[[0,"TlCoolantThro",1,0],[1,"TlCor1RadBuilder",0,"CAM.InheritableDoubleBuilder",0],[0,"TlDesignation",1,0],[1,"TlIncludedAngBuilder",0,"CAM.InheritableDoubleBuilder",0],[1,"TlPilotDiaBuilder",0,"CAM.InheritableDoubleBuilder",0],[1,"TlPilotLengthBuilder",0,"CAM.InheritableDoubleBuilder",0],[1,"TlPitchBuilder",0,"CAM.InheritableDoubleBuilder",0],[1,"TlPointAngBuilder",0,"CAM.InheritableDoubleBuilder",0],[1,"TlPointLengthBuilder",0,"CAM.InheritableDoubleBuilder",0],[0,"TlTaperDiaDistBuilder",0,"CAM.InheritableDoubleBuilder",0],[1,"TlTipDiameterBuilder",0,"CAM.InheritableDoubleBuilder",0],[1,"TlTipLengthBuilder",0,"CAM.InheritableDoubleBuilder",0],[0,"TlToleranceClass",1,0],[1,"TlXOffsetBuilder",0,"CAM.InheritableDoubleBuilder",0],[1,"TlYzOffsetBuilder",0,"CAM.InheritableDoubleBuilder",0]],[],[]];
SPLM.CAM.DrillToolBuilder = class extends SPLM.CAM.MillingToolBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.DrillToolBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;